import React, { useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { 
	FormControl,
	TextField,
	Button,
	FormHelperText,
    OutlinedInput,
    InputAdornment,
	CircularProgress,
} from '@material-ui/core';
import ReCAPTCHA from "react-google-recaptcha";
import { useSnackbar } from 'notistack';

import guestService from '../../services/guestService';
import ErrorValidationAlert from '../alerts/ErrorValidationAlert';

const formSchema = Yup.object().shape({
	email: Yup.string().email().required('Email field is required.'),
	note: Yup.string().nullable().max(250, 'Maximum 250 characters are allowed.'),
    recaptcha: Yup.string().required(),
});

const GOOGLE_RECAPTCHA_SITE_KEY = process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY;

const SharePostForm = (props) => {
  	
    const CHARACTER_LIMIT = 250;
	const [errors, setErrors] = useState("");
    const { enqueueSnackbar } = useSnackbar();
	
	const handleSubmit = (values, formikBag) => {

        setErrors("");
    	const { setSubmitting, resetForm } = formikBag;	 
    
        const formData = new FormData();            
        formData.append('post_id', values.post_id)
        formData.append('email', values.email)
        formData.append('note', values.note)
        formData.append('url', values.url)

        guestService.sharePostThroughEmail(formData)	
            .then((res) => {
                setSubmitting(false)
                if(res.data.success) {
                    resetForm(true)
                    enqueueSnackbar(res.data.message, {
                        variant: 'success',
                        autoHideDuration: 5000,
                    });
                    //props.setDialogIsOpen(false)
                }
            })
            .catch((error) => {
                setSubmitting(false)
                if(error) {
                    setErrors(error.response.data.errors)
                    enqueueSnackbar('Woops! Something went wrong!', {
                        variant: 'error',
                        autoHideDuration: 5000,
                    });
                }
            })
	}

  	return (
		<>
			{errors &&
                <ErrorValidationAlert
                    errors={errors} 
                />
            }
            <Formik 
                initialValues={{ 
                    post_id: props.post_id,
                    email: "", 
                    note: "",
                    url: props.url,
                    recaptcha: ""
                }}
                validationSchema={formSchema}
                onSubmit={handleSubmit}
            >
                {formik => (
                    <form onSubmit={formik.handleSubmit}>
                        <div className="row mt-1 mb-1">
                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <FormControl fullWidth size="small" variant="outlined">
                                    {/* <InputLabel htmlFor="outlined-adornment-to">Email</InputLabel> */}
                                    <OutlinedInput
                                        id="outlined-adornment-to"
                                        {...formik.getFieldProps('email')}
                                        startAdornment={
                                            <InputAdornment position="start">
                                                To
                                            </InputAdornment>
                                        }
                                        labelWidth={0}
                                    />
                                </FormControl>
                                {formik.errors.email &&
                                    <FormHelperText error={true}>{formik.errors.email}</FormHelperText>
                                }
                                <FormHelperText>Email address</FormHelperText>
                            </div>
                        </div>
                        <div className="row mt-1 mb-1">
                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <TextField
                                    id="additional-note"
                                    label="Note (optional)"
                                    multiline
                                    fullWidth
                                    inputProps={{
                                        maxLength: CHARACTER_LIMIT
                                    }}
                                    {...formik.getFieldProps('note')}
                                    maxRows={6}
                                    placeholder="Add a note (optional)"
                                    variant="outlined"
                                    helperText={`${formik.values.note.length}/${CHARACTER_LIMIT}`}
                                />
                                {formik.errors.note &&
                                    <FormHelperText error={true}>{formik.errors.note}</FormHelperText>
                                }
                            </div>
                        </div>
                        <div className="row mt-2 mb-2">
                            <div className="col-md-12 col-sm-12 col-xs-12 d-flex justify-content-center">
                                <div>
                                    <ReCAPTCHA
                                        sitekey={GOOGLE_RECAPTCHA_SITE_KEY}
                                        theme="light"
                                        onChange={(response) => {
                                            formik.setFieldValue("recaptcha", response, true)
                                        }}
                                    />
                                    {formik.errors.recaptcha && 
                                        <FormHelperText error={true}>{formik.errors.recaptcha}</FormHelperText>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="row mt-1 mb-1">
                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    size="medium"
                                    disabled={formik.isSubmitting}
                                    type="submit"
                                >
                                    {formik.isSubmitting && <CircularProgress size={24} />}
                                    {!formik.isSubmitting && 'Share'} 
                                </Button>
                            </div>
                        </div>
                    </form>
                )}
            </Formik>
        </>
  	)
}

export default SharePostForm;